// Relative timestamp for a chat message, scaled to how far back it is:
//   • today      → time only            e.g. "3:24 PM"
//   • yesterday  → "Yesterday" + time   e.g. "Yesterday 3:24 PM"
//   • this week  → weekday + time        e.g. "Wed 3:24 PM"
//   • older      → date + time           e.g. "Jul 2, 2026, 3:24 PM"
// The "yesterday" word is passed in already localized (t('time.yesterday')); weekday/month
// names localize automatically via toLocale*String using the app's current language.

/** Start-of-day epoch ms for a Date (local calendar day). */
function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

export function formatMessageTime(
  createdAt: number,
  yesterdayLabel = 'Yesterday',
  locale?: string,
): string {
  const d = new Date(createdAt);
  if (isNaN(d.getTime())) return '';

  const time = d.toLocaleTimeString(locale, { hour: 'numeric', minute: '2-digit' });
  // Compare by calendar day (not a 24h window) so "yesterday" is correct across the midnight boundary.
  const diffDays = Math.round((startOfDay(new Date()) - startOfDay(d)) / 86_400_000);

  if (diffDays <= 0) return time;                                       // today (≤0 guards clock skew)
  if (diffDays === 1) return `${yesterdayLabel} ${time}`;               // yesterday
  if (diffDays < 7) return `${d.toLocaleDateString(locale, { weekday: 'short' })} ${time}`; // this week
  return `${d.toLocaleDateString(locale, { month: 'short', day: 'numeric', year: 'numeric' })}, ${time}`;
}
